import { stateGnosisPayOnboardingStarted } from '$states/gnosisPayOnboardingStarted.svelte';
import { stateGnosisPayToken } from '$states/gnosisPayToken.svelte';
import { Guard, type GuardRun } from '../utils/Guard';
import { growthBook } from '$services/growthBook';

export class AccessGnosisPayOnboarding extends Guard implements GuardRun {
  run() {
    if (this.target.includes('/gnosis-pay/') && growthBook?.isOff('gnosis_pay_onboarding')) {
      return this.redirectTo('/gnosis-pay');
    }

    if (
      stateGnosisPayOnboardingStarted.current &&
      stateGnosisPayToken.current &&
      !this.target.includes('/gnosis-pay/')
    ) {
      return this.redirectTo('/card/status');
    }
  }
}
